const getCountry = async() => {
  try {
    const res = await fetch('https://www.cloudflare.com/cdn-cgi/trace');
    const text = await res.text();
    const data = Object.fromEntries(text.trim().split('\n').map(l => l.split('=')));
    if (data.loc) return data.loc;
  } catch (e) {}

  try {
    const res = await fetch('https://ipwho.is/');
    const data = await res.json();
    return data.country_code;
  } catch (e) {}

  return null; // both failed
}
const popupViewed = sessionStorage.getItem('announcement-popup-viewed');

let visitorLocation;
(async () => {
  if (!popupViewed) {
    visitorLocation = await getCountry();
  }

const cancelRedirect = document.getElementById('cancel-redirect');
const closeBtn =  document.getElementById('modal_close');
const redirectBtn =  document.getElementById('redirect-user');

const popup = document.querySelector('[data-popupid]');
const currentLocation = Shopify.country;
const targetRedirection = popup.getAttribute('data-target-location')
const origin = window.location.origin
const currentPathname = window.location.pathname
const targetPathname = popup.getAttribute('data-target-pathname')
const request = popup.getAttribute('data-request')
const supportedLocales = ['en-us'];
const supportedLocations = ['US', 'GB'];

const showPopup = (popup) => {
  popup.showModal();
  cancelRedirect.addEventListener('click', closePopup)
  closeBtn.addEventListener('click', closePopup)
  redirectBtn.addEventListener('click', redirectUser)
}

const openPopup = (popup, delay) => {
  setTimeout(() => {
    showPopup(popup)
  }, delay);
}

const closePopup = () => {
  const popup = document.querySelector('[data-popupid]');
  popup.close();
  cancelRedirect.removeEventListener('click', closePopup)
  closeBtn.removeEventListener('click', closePopup)
  redirectBtn.removeEventListener('click', redirectUser)
}

const openPopupForEditor = (target) => {
  const popup = document.querySelector('[data-popupid]');
  if (popup && !popup.open && target.id.includes('market_redirect')){
    showPopup(popup)
  }
}

const closePopupForEditor = (target) => {
  const popup = document.querySelector('[data-popupid]');
  if (popup && popup.open && target.id.includes('market_redirect')){
    closePopup()
  }
}

document.addEventListener("shopify:section:select", function(event) {
  openPopupForEditor(event.target)
});

document.addEventListener("shopify:section:deselect", function(event) {
  closePopupForEditor(event.target)
});

const redirectUser = () => {

    let newPath;
    
    if (targetRedirection !== 'GB'){
      // Add locale prefix if not present
      if (!currentPathname.includes(targetPathname)){
        newPath = `${origin}${targetPathname}${currentPathname}`;
      }
    } else {
      // Remove locale prefix
      const segments = currentPathname.split('/').filter(Boolean)
      const firstSegment = segments[0]
      
      if (supportedLocales.includes(firstSegment)){
        newPath = `${origin}/${segments.slice(1).join('/')}`;
      }
    }
    
    if (newPath) {
      // Preserve query params and hash
      const search = window.location.search;
      const hash = window.location.hash;
      const fullPath = newPath + search + hash;
      
      window.location.href = fullPath;
    }
}

const isSupportedLocation = () => {
  return supportedLocations.includes(visitorLocation) && supportedLocations.includes(currentLocation);
}

if ((currentLocation !== visitorLocation) && isSupportedLocation()){
  const delay = popup.getAttribute('data-open-delay') * 1000;
  if (!popupViewed && !popup.open) {
    openPopup(popup, delay);
    sessionStorage.setItem("announcement-popup-viewed", "true");
  }
}
})();